export const mockThread = [
  {
    name: 'Sender',
    date: 'May 1',
    message: 'Thread 1 nt ut labore et dolore magna aliqua. ',
  },
  {
    name: 'Sender',
    date: 'May 6',
    message:
      'Thread 2, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
  },
];

export const mockMessageWithOneThread = {
  name: 'Sender',
  subject: 'Subject Goes Here ...',
  message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit ...',
  date: 'May 5',
  showThread: false,
  thread: [mockThread[0]],
};

export const mockMessageWithTwoThreads = {
  ...mockMessageWithOneThread,
  showThread: true,
  thread: mockThread,
};

export const mockMessages = [
  mockMessageWithOneThread,
  mockMessageWithTwoThreads,
];
